import React from "react";
import {Routes, Route} from "react-router-dom";
import Login from "./pages/Login";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminLayout from "./pages/AdminLayout";
import AdminListingPage from "./pages/ListingsAdminPage";
import CreateListingPage from './pages/CreateListingPage';
import EditListingPage from './pages/EditListingPage';
import CreateUserPage from "./pages/CreateUserPage";
import EditUserPage from './pages/EditUserPage';
import AdminUserPage from "./pages/AdminUserPage";
import AdminBuyerPage from "./pages/AdminBuyerPage";
import CreateBuyerPage from "./pages/CreateBuyerPage";
import EditBuyerPage from "./pages/EditBuyerPage";
import UserProfilePage from "./pages/UserProfilePage";
import BuyerListingsPage from './pages/BuyerListingsPage';
import ListingDetailPage from './pages/ListingDetailPage';
import NotFoundPage from "./pages/NotFoundPage";
import {useAuth} from "./context/AuthContext";
import {Box, CircularProgress} from "@mui/material";

const AppRouter = () => {
    const {initializing} = useAuth();

    if (initializing) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress/>
            </Box>
        );
    }

    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Login/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route element={<ProtectedRoute/>}>
                <Route path="listings/:id" element={<ListingDetailPage/>}/>
            </Route>

            <Route element={<ProtectedRoute/>}>
                <Route path="/buyer">
                    <Route path="listings" element={<BuyerListingsPage/>}/>
                    <Route path="listings/:id" element={<ListingDetailPage/>}/>
                </Route>
            </Route>

            {/* Protected Admin Routes */}
            <Route element={<ProtectedAdminRoute/>}>
                <Route path="/admin" element={<AdminLayout/>}>
                    <Route path="listings/new" element={<CreateListingPage/>}/>
                    <Route path="listings/edit/:id" element={<EditListingPage/>}/>
                    <Route path="listings" element={<AdminListingPage/>}/>
                    <Route path="users" element={<AdminUserPage/>}/>
                    <Route path="users/new" element={<CreateUserPage/>}/>
                    <Route path="users/edit/:id" element={<EditUserPage/>}/>
                    <Route path="buyers" element={<AdminBuyerPage/>}/>
                    <Route path="buyers/new" element={<CreateBuyerPage/>}/>
                    <Route path="buyers/edit/:id" element={<EditBuyerPage/>}/>
                    <Route path="profile" element={<UserProfilePage/>}/>
                </Route>
            </Route>
            <Route path="*" element={<NotFoundPage/>}/>
        </Routes>
    );
};

export default AppRouter;
